/**
 * Launch Popup - Shows a one-time popup on first visit
 * Uses localStorage to track if popup has been shown
 * Only marks as shown when user clicks close button or action buttons
 */

(function() {
  const STORAGE_KEY = 'van-ark-launch-popup-shown';
  const POPUP_ID = 'LaunchPopup';
  const CLOSE_BUTTON_ID = 'ModalClose-Launch';
  let isMarkedAsShown = false;

  function markAsShown() {
    if (isMarkedAsShown) return; // Prevent multiple calls
    isMarkedAsShown = true;
    localStorage.setItem(STORAGE_KEY, 'true');
  }

  function setupEventListeners() {
    const modal = document.getElementById(POPUP_ID);
    if (!modal) return;

    // Listen for close button click (use capture phase to catch before modal's own handler)
    const closeButton = document.getElementById(CLOSE_BUTTON_ID);
    if (closeButton) {
      closeButton.addEventListener('click', function(event) {
        markAsShown();
      }, true); // Use capture phase
    }

    // Listen for WhatsApp button click
    const whatsappButton = modal.querySelector('.launch-popup-modal__button--whatsapp');
    if (whatsappButton) {
      whatsappButton.addEventListener('click', function() {
        markAsShown();
      });
    }

    // Listen for Email button click
    const emailButton = modal.querySelector('.launch-popup-modal__button--email');
    if (emailButton) {
      emailButton.addEventListener('click', function() {
        markAsShown();
      });
    }

    // Listen for modal close event (when user clicks outside, presses ESC, or closes via button)
    // This event is dispatched by the modal-dialog component
    const modalClosedHandler = function() {
      // Check if our modal was closed
      if (modal && !modal.hasAttribute('open')) {
        markAsShown();
        document.body.removeEventListener('modalClosed', modalClosedHandler);
      }
    };
    
    document.body.addEventListener('modalClosed', modalClosedHandler);
  }

  function showLaunchPopup() {
    // Check if popup has already been shown
    if (localStorage.getItem(STORAGE_KEY) === 'true') {
      return;
    }

    // Wait for page to fully load and custom elements to be registered
    function tryShowPopup() {
      const modal = document.getElementById(POPUP_ID);
      if (modal && typeof modal.show === 'function') {
        // Show the modal (opener is optional, can be null)
        modal.show(null);
        
        // Setup event listeners after modal is shown
        setTimeout(function() {
          setupEventListeners();
        }, 100);
        
        return true;
      }
      return false;
    }

    // Try immediately if DOM is ready
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      // Wait a bit for custom elements to be registered
      setTimeout(function() {
        if (!tryShowPopup()) {
          // If still not ready, try again after a short delay
          setTimeout(tryShowPopup, 500);
        }
      }, 1000);
    } else {
      // Wait for page load
      window.addEventListener('load', function() {
        setTimeout(function() {
          tryShowPopup();
        }, 1000);
      });
    }
  }

  function init() {
    // Only show on first visit
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showLaunchPopup);
    } else {
      showLaunchPopup();
    }
  }

  init();
})();
